import { render, staticRenderFns } from "./FormAverbacao.vue?vue&type=template&id=6153c164&"
import script from "./FormAverbacao.vue?vue&type=script&lang=js&"
export * from "./FormAverbacao.vue?vue&type=script&lang=js&"
import style0 from "./FormAverbacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports